<template src="./DatePicker.html"></template>

<script>
import moment from "moment-timezone";
export default {
  data: () => ({
    windowSize: {
      x: 0,
      y: 0
    },
    valorString: null,
    valorNumber: null,
    formatosPermitidos: [
      "YYYY-MM-DD",
      "DD-MM-YYYY",
      "DD/MM/YYYY",
      "YYYY/MM/DD"
    ],
    valorPicker: "",
    menu: false,
    readonly: false
  }),
  props: {
    value: {
      type: [Number, String],
      default: null
    },
    reglasObligatorio: {
      type: Array,
      default: () => []
    },
    obligatorio: {
      default: false,
      type: Boolean
    },
    label: {
      type: String,
      default: "Label"
    },
    options: {
      type: Object,
      default: function() {
        return { locale: "es", format: "YYYY/MM/DD", clearable: false };
      }
    },
    deshabilitado: {
      type: Boolean,
      default: false
    },
    banderaHasta: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.onResize();
    if (typeof this.value === "string" && !/^\d+$/.test(this.value)) {
      if (moment(this.value, this.formatosPermitidos, true).isValid()) {
        try {
          this.valorPicker = moment(this.value, this.formatosPermitidos, true)
            .tz("America/Bogota")
            .format("YYYY-MM-DD");
        } catch (err) {
          console.log(err);
        } finally {
          const [year, month, day] = this.valorPicker.split("-");
          this.valorString = `${day}/${month}/${year}`;
        }
      }
    } else if (typeof this.value === "string" && /^\d+$/.test(this.value)) {
      try {
        this.valorPicker = moment(Number(this.value))
          .tz("America/Bogota")
          .format("YYYY-MM-DD");
      } catch (err) {
        console.log(err);
      } finally {
        const [year, month, day] = this.valorPicker.split("-");
        this.valorString = `${day}/${month}/${year}`;
      }
    } else if (typeof this.value === "number") {
      try {
        this.valorPicker = moment(this.value)
          .tz("America/Bogota")
          .format("YYYY-MM-DD");
      } catch (err) {
        console.log(err);
      } finally {
        const [year, month, day] = this.valorPicker.split("-");
        this.valorString = `${day}/${month}/${year}`;
      }
    }
  },
  methods: {
    onResize() {
      this.windowSize = { x: window.innerWidth, y: window.innerHeight };
    },
    obtenerTimeStamp(strFecha) {
      try {
        if (moment(strFecha, this.formatosPermitidos, true).isValid()) {
          const a = Number(
            moment(strFecha, this.formatosPermitidos, true)
              .tz("America/Bogota")
              .format("x")
          );
          console.log("valorPicker", this.valorPicker);
          return a;
        } else {
          return null;
        }
      } catch (err) {
        console.log(err);
      }
    },
    seleccionarPicker() {
      if (!this.valorPicker) return;
      const [year, month, day] = this.valorPicker.split("-");
      this.valorString = `${day}/${month}/${year}`;
    }
  },
  watch: {
    valorString(newValue, oldValue) {
      this.valorNumber = this.obtenerTimeStamp(newValue);
      if (this.valorNumber !== null) {
        try {
          if (moment(newValue, this.formatosPermitidos, true).isValid()) {
            if (this.valorPicker !== newValue) {
              this.valorPicker = moment(newValue, this.formatosPermitidos, true)
                .tz("America/Bogota")
                .format("YYYY-MM-DD");
            }
          }
          this.$emit("input", this.valorNumber);
        } catch (err) {
          console.log(err);
        }
      } else {
        this.valorPicker = null;
      }
    }
  }
};
</script>

<style lang="scss" src="./DatePicker.scss" scoped></style>
